import api from "../../Environment";
import { put, takeLatest, all } from "redux-saga/effects";

import { FETCH_SITE_STAT_START } from "../../store/actions/ActionConstant";
import { fetchSiteStatFailed } from "../../store/actions/SiteStatisticAction";
import { fetchSiteStatSuccess } from "../../store/actions/SiteStatisticAction";

import { FETCH_HELP_AND_SUPPORT_CONTENT_START } from "../../store/actions/ActionConstant";
import { fetchHelpAndSupportFailed } from "../../store/actions/SiteStatisticAction";
import { fetchHelpAndSupportSuccess } from "../../store/actions/SiteStatisticAction";
import { showErrorComponent } from "../actions/ComponentAction";

function* fetchSiteStatisticApi() {
  try {
    const response = yield api.getMethod("reports/get_company_summary");
    if (response.data.success) {
      yield put(
        fetchSiteStatSuccess({
          data: response.data.data,
          message: "Stats fetched successfully",
        })
      );
    } else {
      yield put(
        fetchSiteStatFailed({
          error: response.data.error,
          message: "Stats fetched failed",
        })
      );
    }
  } catch (error) {
    yield put(
      fetchSiteStatFailed({
        error: error,
        message: "Stats fetched failed",
      })
    );
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchHelpAndSupportContent() {
  try {
    const response = yield api.getMethod("help_and_support");
    if (response.data.success) {
      yield put(
        fetchHelpAndSupportSuccess({
          data: response.data.data,
          message: "Help and support content fetched successfully",
        })
      );
    } else {
      yield put(
        fetchHelpAndSupportFailed({
          error: response.data.error,
          message: "Help and support content fetch failed",
        })
      );
    }
  } catch (error) {
    yield put(
      fetchHelpAndSupportFailed({
        error: error,
        message: "Help and support content fetch failed",
      })
    );
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

export default function* siteStatisticSaga() {
  yield all([yield takeLatest(FETCH_SITE_STAT_START, fetchSiteStatisticApi)]);
  yield all([yield takeLatest(FETCH_HELP_AND_SUPPORT_CONTENT_START, fetchHelpAndSupportContent)]);
}
